// src/utils/blankWindowGuard.ts
// Flutter(WKWebView) 内でのみ、空URL/about:blank を開こうとする window.open を無視するガード。
//
// ■ 背景
//   Flutter ホストの navigationDelegate は about:blank を「外部URL」と判定し、
//   url_launcher で外部ブラウザに開こうとする（main.dart 参照）。これが地図の
//   二本指操作中などに連続発火すると、外部起動の連打でアプリがハングする。
//   そのため、about:blank を生む window.open を Web 側で元から出さないようにする。
//
// ■ 方針（最小・無害）
//   - Flutter 内でのみ有効化（ブラウザ単体の挙動は一切変えない）。
//   - 空文字 / 'about:blank' のときだけ no-op（null を返す）。実URLは従来どおり開く。
//   - これは「JSの window.open('about:blank') が発生源」の場合にのみ効く。
//     Google Maps 内部の iframe(サブフレーム)が発生源の場合は Web 側では止められない
//     （その場合は Flutter 側で about:blank/!isMainFrame を除外する必要がある）。

import { isInFlutter } from './flutterDetection';

let installed = false;

/** 空/about:blank の window.open を Flutter 内で無効化する（多重適用はしない）。 */
export function installBlankWindowGuard(): void {
  if (installed || typeof window === 'undefined' || typeof window.open !== 'function') {
    return;
  }
  installed = true;

  const nativeOpen = window.open.bind(window);

  window.open = function (
    url?: string | URL,
    target?: string,
    features?: string
  ): Window | null {
    const u = url == null ? '' : String(url);
    if (isInFlutter() && (u === '' || u === 'about:blank')) {
      // about:blank を外部起動させないため開かない。
      console.warn('[blankWindowGuard] Flutter内で空/about:blankのwindow.openを抑止しました');
      return null;
    }
    return nativeOpen(url as any, target as any, features as any);
  } as typeof window.open;
}
